<template>
    <div>
        <!-- tabs -->
        <v-tabs v-model="tab" show-arrows height="35">
            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'salaries'
                }"
            >
                تفاصيل الراتب
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'salaries-view'
                }"
            >
                الراتب
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider class="mb-2"/>

        <!-- child page -->
        <loader v-if="loading"/>
        <router-view v-else/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tab: 0,
            loading: false
        }
    }
}
</script>
